import { render, staticRenderFns } from "./LoadDialog.vue?vue&type=template&id=54be8566"
import script from "./LoadDialog.vue?vue&type=script&lang=js"
export * from "./LoadDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports